const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const ShopItemAdd = () => import(/* webpackChunkName: "shop" */ '@/modules/shop/view/add.vue');
const ShopItemEdit = () => import(/* webpackChunkName: "shop" */ '@/modules/shop/view/edit.vue');
const ShopItemList = () => import(/* webpackChunkName: "shop" */ '@/modules/shop/view/index.vue');
const ShopItemTranslate = () => import(/* webpackChunkName: "shop" */ '@/modules/shop/view/translate.vue');

export const ROUTE_NAME_SHOP = {
    INDEX: 'ShopItemList',
    ADD: 'ShopItemAdd',
    EDIT: 'ShopItemEdit',
    CLONE: 'ShopItemClone',
    TRANSLATE: 'ShopItemTranslate'
} as const;

export default [
    {
        path: '/app/:appId/shop',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_SHOP.INDEX,
                component: ShopItemList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_SHOP.ADD,
                component: ShopItemAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/clone',
                name: ROUTE_NAME_SHOP.CLONE,
                component: ShopItemAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_SHOP.EDIT,
                component: ShopItemEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/translate',
                name: ROUTE_NAME_SHOP.TRANSLATE,
                component: ShopItemTranslate,
                meta: { requiresAuth: true }
            }
        ]
    }
];
